import { Currency } from 'store/api/enums';
import Features from 'store/billing/models/features.json';
import {
  formatNumberWithLocale,
  getDefaultLocale,
} from 'utils/numberFormat';

//to be retrieved from API. Pass locale from useNumberFormat() for user preference.
export const calcCurrencyAmount = (
  selectedCurrency: Currency,
  amount: number,
  withSymbol = true,
  locale?: string
) => {
  const loc = locale ?? getDefaultLocale();
  switch (selectedCurrency) {
    case Currency.EUR:
      return `${withSymbol ? '€' : ''} ${formatNumberWithLocale(loc, amount * 1)}`;
    case Currency.AED:
      return `${withSymbol ? 'Dh' : ''} ${formatNumberWithLocale(loc, amount * 0.83)}`;
    case Currency.USD:
      return `${withSymbol ? '$' : ''} ${formatNumberWithLocale(loc, amount * 1.04)}`;
    default:
      return undefined;
  }
};

const getFormattedPrice = (
  price: string,
  symbol: string,
  withSymbol: boolean,
  locale?: string
) => {
  if (price !== 'n/a') {
    const numericPrice = parseFloat(price);
    if (!isNaN(numericPrice)) {
      const loc = locale ?? getDefaultLocale();
      const formatted = formatNumberWithLocale(loc, numericPrice);
      return withSymbol ? `${symbol} ${formatted}` : formatted;
    }
  }
  return price; // Return 'n/a' or original string if not a valid number
};

export const getPriceByCurrency = (
  selectedCurrency: Currency,
  featureId,
  planType,
  withSymbol = true,
  locale?: string
) => {
  if (planType?.toLowerCase() != 'free') {
    const feature = Features.find((feature) => feature.featureId == featureId);
    const featurePlan = feature ? feature[planType] : null;
    let featurePrice = '';
    switch (selectedCurrency) {
      case Currency.EUR:
        featurePrice = featurePlan[Currency.EUR.toString()];
        return getFormattedPrice(featurePrice, '€', withSymbol, locale);
      case Currency.AED:
        featurePrice = featurePlan[Currency.AED.toString()];
        return getFormattedPrice(featurePrice, 'Dh', withSymbol, locale);
      case Currency.USD:
        featurePrice = featurePlan[Currency.USD.toString()];
        return getFormattedPrice(featurePrice, '$', withSymbol, locale);
      default:
        return undefined;
    }
  }
};

export const calcPriceCurrency = (
  selectedCurrency: Currency,
  withSymbol = true
) => {
  switch (selectedCurrency) {
    case Currency.EUR:
      return `${withSymbol ? '€' : ''} 19`;
      break;
    case Currency.AED:
      return `${withSymbol ? 'Dh' : ''} 76`;
      break;
    case Currency.USD:
      return `${withSymbol ? '$' : ''} 210`;
      break;
    default:
      break;
  }
};

export const getCurrencySymbol = (selectedCurrency: Currency) => {
  switch (selectedCurrency) {
    case Currency.EUR:
      return '€';
      break;
    case Currency.AED:
      return 'Dh';
      break;
    case Currency.USD:
      return '$';
      break;
    default:
      break;
  }
};
